import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const TermsAndConditionsPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          {/* Page Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl lg:text-5xl font-bold text-[#2F6FE4] mb-4">
              Terms and Conditions
            </h1>
            <p className="text-[#555555] text-sm">
              Last Updated: January 2025
            </p>
          </div>

          {/* Section 1: Introduction */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-[#2F6FE4] mb-4">
              1. Introduction
            </h2>
            <p className="text-[#555555] leading-relaxed mb-4">
              These Terms and Conditions govern the use of The Broker Marketplace website and services. By accessing this website or submitting information through the platform, users agree to comply with these terms.
            </p>
            <p className="text-[#555555] leading-relaxed">
              The Broker Marketplace provides services related to business credit development and broker partnerships.
            </p>
          </section>

          {/* Section 2: Website Use */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-[#2F6FE4] mb-4">
              2. Website Use
            </h2>
            <p className="text-[#555555] leading-relaxed mb-4">
              Users may use the website to learn about services, apply as brokers, and submit deals.
            </p>
            <ul className="space-y-3">
              <li className="flex items-start">
                <span className="w-2 h-2 bg-[#2F6FE4] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span className="text-[#555555]">Users agree to provide accurate information when submitting forms.</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-[#2F6FE4] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span className="text-[#555555]">Users may not use the website for unlawful purposes.</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-[#2F6FE4] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span className="text-[#555555]">Users may not attempt to disrupt the website or interfere with its operation.</span>
              </li>
            </ul>
          </section>

          {/* Section 3: Broker Participation */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-[#2F6FE4] mb-4">
              3. Broker Participation
            </h2>
            <p className="text-[#555555] leading-relaxed mb-4">
              The Broker Marketplace allows brokers to submit clients for services related to business credit development.
            </p>
            <ul className="space-y-3">
              <li className="flex items-start">
                <span className="w-2 h-2 bg-[#2F6FE4] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span className="text-[#555555]">Brokers must provide accurate client information.</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-[#2F6FE4] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span className="text-[#555555]">Brokers must ensure clients understand service pricing before submission.</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-[#2F6FE4] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span className="text-[#555555]">Brokers must follow the broker guidelines outlined on the website.</span>
              </li>
            </ul>
          </section>

          {/* Section 4: Deal Submission */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-[#2F6FE4] mb-4">
              4. Deal Submission
            </h2>
            <p className="text-[#555555] leading-relaxed mb-4">
              Brokers may submit client deals through the deal submission page on the website.
            </p>
            <div className="bg-[#F2F4F7] border-l-4 border-[#2F6FE4] p-4 rounded">
              <p className="text-[#555555] leading-relaxed">
                Submission of a deal does not guarantee that services will begin. All submissions are reviewed before processing.
              </p>
            </div>
          </section>

          {/* Section 5: Payment Policy */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-[#2F6FE4] mb-4">
              5. Payment Policy
            </h2>
            <p className="text-[#555555] leading-relaxed mb-4">
              Services will not begin until the required payment has been received by The Broker Marketplace.
            </p>
            <p className="text-[#555555] leading-relaxed">
              If a broker collects payment from a client, the broker must submit the payment to The Broker Marketplace within 24 hours in order for service processing to begin.
            </p>
          </section>

          {/* Section 6: Broker Conduct */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-[#2F6FE4] mb-4">
              6. Broker Conduct
            </h2>
            <ul className="space-y-3">
              <li className="flex items-start">
                <span className="w-2 h-2 bg-[#2F6FE4] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span className="text-[#555555]">Brokers may not misrepresent services offered through the platform.</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-[#2F6FE4] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span className="text-[#555555]">Brokers may not guarantee funding approvals or credit score increases.</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-[#2F6FE4] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span className="text-[#555555]">Brokers must communicate service pricing clearly to clients.</span>
              </li>
            </ul>
          </section>

          {/* Section 7: Service Disclaimer */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-[#2F6FE4] mb-4">
              7. Service Disclaimer
            </h2>
            <div className="bg-[#F2F4F7] border-l-4 border-[#2F6FE4] p-4 rounded">
              <p className="text-[#555555] leading-relaxed mb-4">
                The Broker Marketplace provides services intended to assist businesses in developing stronger business credit profiles.
              </p>
              <p className="text-[#555555] leading-relaxed mb-4">
                The Broker Marketplace does not guarantee credit score increases, funding approvals, or specific financial outcomes.
              </p>
              <p className="text-[#555555] leading-relaxed">
                Reporting timelines vary depending on vendor processing and credit bureau reporting cycles.
              </p>
            </div>
          </section>

          {/* Section 8: Limitation of Liability */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-[#2F6FE4] mb-4">
              8. Limitation of Liability
            </h2>
            <p className="text-[#555555] leading-relaxed mb-4">
              The Broker Marketplace is not responsible for decisions made by lenders, vendors, or credit bureaus.
            </p>
            <p className="text-[#555555] leading-relaxed">
              The Broker Marketplace shall not be liable for indirect or consequential damages resulting from the use of the website or services.
            </p>
          </section>

          {/* Section 9: Third Party Services */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-[#2F6FE4] mb-4">
              9. Third Party Services
            </h2>
            <p className="text-[#555555] leading-relaxed mb-4">
              The platform may rely on third party tools and vendors to provide services.
            </p>
            <p className="text-[#555555] leading-relaxed">
              These third party providers operate independently and The Broker Marketplace is not responsible for their policies or decisions.
            </p>
          </section>

          {/* Section 10: Intellectual Property */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-[#2F6FE4] mb-4">
              10. Intellectual Property
            </h2>
            <p className="text-[#555555] leading-relaxed">
              All content on The Broker Marketplace website, including text, graphics, and branding, is the property of The Broker Marketplace and may not be reproduced without permission.
            </p>
          </section>

          {/* Section 11: Changes to Terms */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-[#2F6FE4] mb-4">
              11. Changes to Terms
            </h2>
            <p className="text-[#555555] leading-relaxed">
              The Broker Marketplace may update these Terms and Conditions from time to time. Updates will be posted on this page with a revised date.
            </p>
          </section>

          {/* Section 12: Contact Information */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-[#2F6FE4] mb-4">
              12. Contact Information
            </h2>
            <div className="bg-[#F2F4F7] p-6 rounded-lg">
              <p className="text-[#555555] font-semibold mb-2">The Broker Marketplace</p>
              <p className="text-[#555555]">
                Email: <a href="mailto:kenwright@thebrokermarketplace.com" className="text-[#2F6FE4] hover:underline cursor-pointer">kenwright@thebrokermarketplace.com</a>
              </p>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsAndConditionsPage;